export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password: string): boolean => {
  return password.length >= 12;
};

export const validateNickname = (nickname: string): boolean => {
  return nickname.length >= 2 && nickname.length <= 20;
};

export const formatPhoneNumber = (value: string): string => {
  const digits = value.replace(/\D+/g, '');
  return digits.replace(/(.{3})/g, '$1 ').trim();
};

export const getOnlyDigits = (value: string): string => {
  return value.replace(/\D+/g, '');
};
